"use client";

import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { SkipNavContent } from "@chakra-ui/skip-nav";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navbar />
      <SkipNavContent>
        <main>{children}</main>
      </SkipNavContent>
      <Footer />
    </>
  );
}
